import React from 'react';

// Styles & Assets
import styles from './CalendarWeek.module.css';

// Other
import moment from 'moment';

// Hooks
import { useTranslation } from 'react-i18next';
import EventSummary from '../EventSummary/EventSummary';

// Interfaces
interface Props {
    startDay: moment.Moment
}

const CalendarWeek: React.FC<Props> = ({ startDay }) => {

    const { t } = useTranslation();

    return (
        <div className={styles.weekContainer}>
            <div className={styles.day}>
                <p className={styles.text}><span>{t('monday')}</span> {startDay.date()}</p>
                <EventSummary onClick={() => undefined}/>
            </div>
            <div className={styles.day}>
                <p className={styles.text}><span>{t('tuesday')}</span> {startDay.clone().add(1, 'day').date()}</p>
            </div>
            <div className={styles.day}>
                <p className={styles.text}><span>{t('wednesday')}</span> {startDay.clone().add(2, 'day').date()}</p>
            </div>
            <div className={styles.day}>
                <p className={styles.text}><span>{t('thursday')}</span> {startDay.clone().add(3, 'day').date()}</p>
            </div>
            <div className={styles.day}>
                <p className={styles.text}><span>{t('friday')}</span> {startDay.clone().add(4, 'day').date()}</p>
            </div>
        </div>
    );
};

export default CalendarWeek;